export default __webpack_public_path__ + "static/media/02.3.444dd5b7.jpg";